import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from './storage.service';
import { MessageService } from './message.service';
import { DialogService } from './dialog.service';
import { LayoutService } from './layout.service';
import { TranslateService } from './translate.service';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root',
})
export class ComponentService {
  constructor(
    public loader: LoaderService,
    public router: Router,
    public localStorage: LocalStorageService,
    public message: MessageService,
    public dialog: DialogService,
    public location: Location,
    public layout: LayoutService,
    public translate: TranslateService,
    public title: Title
  ) {}
}
